import React, { lazy, Suspense } from 'react'
import { Redirect, Switch, useRouteMatch } from 'react-router-dom'
import { SecureRoute } from '@okta/okta-react'
import { Hidden } from '@material-ui/core'
import { useAuthToken } from '../../providers/AuthProvider'
import { useHideSideMenuEffect } from '../../redux/slices/appContext'
import NotAvailable from '../../components/organisms/NotAvailable'
import { usePolicy } from '../../hooks/usePolicy'
import { useFeatureFlag } from '../../redux/slices/appConfig'
import { FEATURE_FLAG } from '../../constants'
import AssistantLayout from './Assistant/AssistantLayout'
import ChatInterface from './Assistant/Chat/ChatInterface'
import Landing from './Assistant/Landing'
import MobileLandingPage from './Assistant/MobileLanding'
import Schedules from './Assistant/Schedules'
import Skills from './Assistant/Skills'
import Meetings from './Assistant/Meetings'
import Settings from './Assistant/Settings'
import HistoryIndex from './Assistant/History'
import ReadingListIndex from './Assistant/ReadingList'
import NotFoundView from './Assistant/common/NotFoundView'

const ArtifactPage = lazy(() => import('./Assistant/ArtifactPage'))

function AiApp () {
  const { path } = useRouteMatch()
  const { isLoading } = useAuthToken()
  const isAiEnabled = usePolicy('denali_ai_enabled')
  const { active: meetingsEnabled } = useFeatureFlag(FEATURE_FLAG.DENALI_MEETINGS)

  useHideSideMenuEffect([])

  if (!isAiEnabled) {
    return (
      <NotAvailable />
    )
  }

  if (isLoading) {
    return null
  }

  return (
    <Switch>
      <SecureRoute path={`${path}/artifact/:threadId/:attachmentId`}>
        <Suspense fallback={null}>
          <ArtifactPage />
        </Suspense>
      </SecureRoute>
      <SecureRoute path={path}>
        <AssistantLayout>
          <Switch>
            <SecureRoute path={`${path}`} exact>
              <Redirect to={`${path}/new`} />
            </SecureRoute>
            <SecureRoute path={`${path}/new`}>
              <>
                <Hidden xsDown>
                  <Landing />
                </Hidden>
                <Hidden smUp>
                  <MobileLandingPage />
                </Hidden>
              </>
            </SecureRoute>
            <SecureRoute path={`${path}/chat/:threadId`}>
              <ChatInterface />
            </SecureRoute>
            <SecureRoute path={`${path}/schedules`}>
              <Schedules />
            </SecureRoute>
            <SecureRoute path={`${path}/skills`}>
              <Skills />
            </SecureRoute>
            {meetingsEnabled && (
              <SecureRoute path={`${path}/meetings`}>
                <Meetings />
              </SecureRoute>
            )}
            <SecureRoute path={`${path}/settings`}>
              <Settings />
            </SecureRoute>
            <SecureRoute path={`${path}/history`}>
              <HistoryIndex />
            </SecureRoute>
            <SecureRoute path={`${path}/reading-list`}>
              <ReadingListIndex />
            </SecureRoute>
            <SecureRoute path='*'>
              <NotFoundView />
            </SecureRoute>
          </Switch>
        </AssistantLayout>
      </SecureRoute>
    </Switch>
  )
}

export default AiApp
